import {Component, Input, OnInit} from '@angular/core';
import {ConsultantService} from '../_services/consultant.service';
import {LoginService} from '../_services/login.service';
import {environment} from '../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import {NoticeService} from '../_services/notice.service';
import {
  NgbCalendar,
  NgbDate,
  NgbDateStruct,
  NgbInputDatepickerConfig,
  NgbRatingConfig
} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DefinitionService} from '../_services/definition.service';
import {Definitions} from '../_models/definitions';
import {Store} from '@ngrx/store';
import {AppState} from '../app.state';
import * as dayjs from 'dayjs';
import 'dayjs/locale/fr';
import * as timezone from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
import {Session} from '../_models/session';
import {SessionService} from '../_services/session.service';
import {Router} from '@angular/router';
import {CryptoService} from '../_services/crypto.service';
import {HomeService} from '../_services/home.service';

declare var $: any;

@Component({
  selector: 'app-consultant',
  templateUrl: './consultant.component.html',
  styleUrls: ['./consultant.component.css'],
  providers: [NgbRatingConfig]
})
export class ConsultantComponent implements OnInit {

  definitions: Observable<Definitions>;
  session: Observable<Session>;
  @Input() servicetype: string;
  @Input() timeZoneClient: string;
  @Input() isPlanned: boolean;
  @Input() setfilter: boolean;
  data: any;
  isValidtoken: boolean;
  isLoggedIn$: Observable<boolean>;
  listData: any;
  listDataFiltered: any = [];
  listDataOriginal: any;
  consultationModesFilter: any = [];
  voyanceTypesFilter: object = null;
  languagesTypesFilter: object = null;
  filters: any = {consultantName: '', consultationModesFilter: [], voyanceTypesFilter: [], languagesTypesFilter: [], timeFrames: ''};
  consultantNotice: any;
  consultantReviews: any;
  transactions: any;
  consultantImageUrl: any;
  consultantName: any;
  customerNoticeNotation = 0;
  hovered = 0;
  readonly = false;
  formAddReview: FormGroup;
  customerRemark: string;
  consultantId: any;
  transactionStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  tooltipClass: string;
  startHour;
  endHour;
  customerCountries: string[];
  svaNumber: string;
  svaNumberTariff: string;
  svaNumberPrice: string;
  svaNumbers = {
    A005: 'Service 0,05€/appel <br/> + prix appel',
    D040: 'Service 0,40€/min <br/> + prix appel',
    A008: 'Service 0,08 €/appel <br/> + prix appel',
    A009: 'Service 0,09 €/appel  <br/> + prix appel',
    A010: 'Service 0,10 €/appel <br/>  + prix appel',
    A012: 'Service 0,12 €/appel <br/>  + prix appel',
    A015: 'Service 0,15 €/appel <br/>  + prix appel',
    A020: 'Service 0,20 €/appel <br/>  + prix appel',
    A030: 'Service 0,30 €/appel <br/> + prix appel',
    A040: 'Service 0,40 €/appel <br/> + prix appel',
    A050: 'Service 0,50 €/appel <br/> + prix appel',
    A060: 'Service 0,60 €/appel <br/>+ prix appel',
    A065: 'Service 0,65 €/appel <br/> + prix appel',
    A079: 'Service 0,79 €/appel <br/> + prix appel',
    A080: 'Service 0,80 €/appel <br/>  + prix appel',
    A090: 'Service 0,90 €/appel <br/> + prix appel',
    A099: 'Service 0,99 €/appel <br/> + prix appel\n',
    A100: 'Service 1 €/appel <br/> + prix appel',
    A150: 'Service 1,5 €/appel <br/>  + prix appel',
    A199: 'Service 1,99 €/appel <br/> + prix appel',
    A200: 'Service 2 €/appel <br/> + prix appel',
    A250: 'Service 2,5 €/appel <br/> + prix appel',
    A299: 'Service 2,99 €/appel <br/> + prix appel',
    A300: 'Service 3 €/appel <br/>  + prix appel',
    D005: 'Service 0,05 €/min  <br/>  + prix appel',
    D006: 'Service 0,06 €/min <br/>  + prix appel',
    D009: 'Service 0,09 €/min <br/>+ prix appel',
    D010: 'Service 0,10 €/min <br/> + prix appel',
    D012: 'Service 0,12 €/min <br/> + prix appel',
    D015: 'Service 0,15 €/min  <br/> + prix appel',
    D018: 'Service 0,18 €/min <br/> + prix appel',
    D020: 'Service 0,20 €/min  <br/> + prix appel',
    D025: 'Service 0,25 €/min <br/> + prix appel',
    D030: 'Service 0,30 €/min <br/> + prix appel',
    D035: 'Service 0,35 €/min <br/> + prix appel',
    D045: 'Service 0,45 €/min <br/> + prix appel',
    D050: 'Service 0,50 €/min <br/> + prix appel',
    D060: 'Service 0,60 €/min  <br/>  + prix appel',
    D070: 'Service 0,70 €/min <br/>  + prix appel',
    D080: 'Service 0,80 €/min <br/>  + prix appel',
    M001: 'Service 0,08 €/appel  <br/>+ 0,02€/min',
    M002: 'Service 0,12 €/appel <br/> + 0,04€/min'
  };
  showSVADetails = false;
  consultantInfo: any;
  result: any;
  isLogging: boolean;
  langTitle = {FR: '', ES: '¡ Yo también hablo español !', EN: 'I also speak english !'};
  consultationModesTitle = {
    AUDIOTEL: 'Je consulte en appelant un numéro surtaxé',
    CB: ' Avec ma CB, j\'effectue une conversation privée',
    CHAT: 'Avec ma CB, je chatte avec un consultant',
    MAIL: 'Avec ma CB, je reçois ma consultation par email'
  };
  public showAddNotice: any;
  public showAllNotice: any;
  activateLink = false;
  voyanceTypes = [
    'tarologist_type',
    'runes_type',
    'astrologer_type',
    'fortune_teller_type',
    'oracle_type',
    'numerologist_type',
    'psychic_seer_type',
    'pendulum_type',
    'dowsing_type',
    'medium_type',
  ];
  loading = true;
  timeFrames = [];
  public slideConfig: {};
  startSlider: number ;
  listDataCloned = [];
  startDate = dayjs().format('DD/MM/YYYY');
  model: NgbDateStruct;
  isDisabled: any;
  dayName: string;
  dayNumber: string;
  yearNumber: string;
  monthName: string;
  minDate: { month: number; year: number; day: number };
  maxDate: { month: number; year: number; day: number };

  constructor(
    public  consultantservice: ConsultantService,
    private  loginservice: LoginService,
    private  noticeService: NoticeService,
    private  definitionService: DefinitionService,
    config: NgbRatingConfig,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private sessionService: SessionService,
    private router: Router,
    private cryptoService: CryptoService,
    private homeService: HomeService,
    configDatePicker: NgbInputDatepickerConfig,
    calendar: NgbCalendar
  ) {
    dayjs.extend(utc);

    dayjs.extend(timezone);

    this.definitions = store.select('definitions');
    config.max = 5;
    config.readonly = true;
    this.session = store.select('session');

    this.session.subscribe(({isLoggedIn}) => {
      this.isLogging = !isLoggedIn;
    });
    configDatePicker.outsideDays = 'hidden';

    const [minDate, maxDate] = [new Date(), new Date()];
    maxDate.setDate(maxDate.getDate() + 6);
    this.minDate = {year: minDate.getFullYear(), month: minDate.getMonth() + 1, day: minDate.getDate()};
    this.maxDate = {year: maxDate.getFullYear(), month: maxDate.getMonth() + 1, day: maxDate.getDate()};

   // this.isDisabled = (date: NgbDate, current: {month: number}) => date.day > Number(dayjs().add(6, 'day').format('DD')) ||  date.day <  Number(dayjs().format('DD')) ;
    configDatePicker.autoClose = 'outside';
    configDatePicker.outsideDays = 'collapsed';

    configDatePicker.placement = ['right'];
    configDatePicker.navigation = 'none';
    configDatePicker.displayMonths = 1;
  }

  get f() {
    return this.formAddReview.controls;
  }

  ngOnInit(): void {
    if (this.servicetype) {
      this.setfilter = JSON.parse(String(this.setfilter));
    }
    this.timeFrames = this.generateTimeFrame();
    this.getCurrentActiveEl(dayjs());
    this.slideConfig = {
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      initialSlide: this.startSlider,
      vertical: true,
      verticalSwiping: true,
      swipeToSlide: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 300,
          settings: {
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 2,
            initialSlide: this.startSlider
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 4,
            vertical: true,
            verticalSwiping: true,
            initialSlide: this.startSlider
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 6,
            vertical: false,
            verticalSwiping: false,
            initialSlide: this.startSlider
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 10,
            vertical: false,
            verticalSwiping: false,
            initialSlide: this.startSlider
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 7,
            vertical: false,
            slidesToScroll: 1,
            verticalSwiping: false,
            initialSlide: this.startSlider,
            infinite: false,
          }
        },
        {
          breakpoint: 2500,
          settings: {
            slidesToShow: 7,
            vertical: false,
            verticalSwiping: false,
            initialSlide: this.startSlider,
            swipeToSlide: true,
            infinite: false,

          }
        }
      ]
    };

    dayjs.locale('fr');
    this.isLoggedIn$ = this.loginservice.isLoggedIn;
    this.definitions.subscribe(definitions => {
      environment.merchantId = definitions?.merchantId;
      environment.officeId = definitions?.officeId;
      this.svaNumber = definitions?.sva_number;
      this.svaNumberTariff = definitions?.sva_number_tariff;
      this.customerCountries = definitions?.customer_countries || [];
      this.getSVANumberData(this.customerCountries);
      this.listConsultant(this.servicetype, this.isPlanned, this.setfilter);

    });
    this.formAddReview = this.fb.group({
      customerRemark: ['', [
        Validators.required,
      ]],
    });
    $('#modalConsultantReviews').on('hidden.bs.modal', () => {

      $('.hiddenNotice').hide();
      $('#btnShowAllNotices').show();
      this.customerNoticeNotation = 0;
      this.formAddReview.reset();
      $('#consultantAddNotice').hide();
      $('#consultantAllNotices').show();
      this.showAllNotice = false;

    });
    this.isValidtoken = localStorage.getItem('customerSessionId') !== null;
    this.isLoggedIn$ = this.loginservice.isLoggedIn;
    this.consultantNotice = [];
    this.consultantReviews = [];
    if(!this.timeZoneClient){
      this.timeZoneClient= Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    this.dayName = dayjs().format('dddd');
    this.dayNumber = dayjs().format('DD');
    this.monthName = dayjs().format('MMMM');
    this.yearNumber = dayjs().format('YYYY');
      /**
       * ask user to refresh page every 20 minutes
       */
    setInterval(() => {
      $('#refresh-page-modal').modal('show');
    }, 20*60*1000);

  }

  /**
   * Get List of consultants
   * @param serviceType
   * @param isplanned
   * @param setFilter
   */

   listConsultant(serviceType = 'all', isplanned = true, setFilter = false  ) {
    if (environment.merchantId && environment.officeId) {
      console.log(this.timeZoneClient);
      this.consultantservice.sendGetConsutalnt(environment.merchantId, environment.officeId, this.timeZoneClient).subscribe(
         (res: any) => {
          this.loading = false;
          // Hide the consultants that are only available via Chat from the CB page
          this.listData = res.body.data;
          console.log(this.listData);
          
         //   res.body.data.filter(item => item.prestations.length > 1 || (item.prestations.length == 1 && item.prestations[0].toLowerCase() != 'chat'));
           this.listData.forEach( (consultant) => {
            const result = this.consultantservice.handle(consultant, this.setfilter, this.servicetype);
            consultant.statut = result.statut;
            consultant.statutColor = result.colorClass;
            consultant.prestationSorted = result.prestations;
            consultant.statutCode = result.statutCode;
            consultant.cost = result.cost;
            consultant.date = result.date;
            consultant.service = result.service;
            consultant.isPlannedForToday = result.isPlannedForToday;
            consultant.framesDetails = result.framesDetails;
            consultant.planningDays = result.planningDays;
            consultant.currentService = result.currentService;
            consultant.startHour = [];
            if (consultant.planningDays.length > 0) {
              result.planningDays.forEach(el => {
                el.startHour.forEach(elm => {
                  consultant.startHour.push(elm);
                });

              });
            }

          });

          this.listData.sort((a, b) => {
            if (b.statutCode === -1) {
              return -1;
            }
            if ((a.statutCode === 0 || a.statutCode === 1) && (b.statutCode === 0 || b.statutCode === 1)) {
              return (a.statutCode < b.statutCode || (b.service !== 'Conversation' && a.statutCode === 0)) ? -1 : 1;
            }
            if (b.statutCode === 2) {
              return dayjs(a.date) < dayjs(b.date) ? -1 : 1;
            }
            return 1;
          });

          if (setFilter && serviceType === 'Conversation') {
            console.log(this.listData, ' first ');
            
            this.listData = this.listData.filter(data => (data.isPlannedForToday === isplanned && (data.currentService.includes('cb') ||  data.currentService.includes('chat'))));
            console.log(this.listData, ' 2 ');
            this.listDataOriginal = this.listData;
            this.listData = this.filterService(this.listData);
            console.log(this.listData, ' 3 ');
          } else if (setFilter && serviceType === 'Audiotel') {
            this.listDataCloned = this.listData;
            const currentHour = dayjs().format('HH') + 'h';
            this.listData.forEach(elementData => {
              elementData.planningDays.forEach(el => {
                if (el.day === dayjs().format('YYYY-MM-DD')) {
                  elementData.startHour = el.startHour;
                  elementData.service = 'audiotel';
                }
              });
            });
            this.listData = this.listData.filter(data => (
              data.service === serviceType.toLowerCase() && data.isPlannedForToday === isplanned && dayjs(data.date).format('HH') === dayjs().format('HH')
              && data.statutCode === 0 && data.startHour.includes(currentHour)));
            this.listDataOriginal = this.sortByTouchNumber(this.listData, currentHour, dayjs());
          } else if (serviceType === 'all') {
            this.listDataOriginal = this.listData;
            this.listData = this.filterService(this.listData);

          } else {
            serviceType = serviceType === 'Conversation' ?'cb':serviceType;
            this.listData = this.listData.filter(data => (data.currentService.includes(serviceType)));
            this.listDataOriginal = this.listData;
            this.listData = this.filterService(this.listData);

          }
        },
        error => {
          console.log(error);
        }
      );
    }
    
  }

  /**
   *
   * @param consultant
   * @constructor
   */
  ModalConsultantReviews(consultant) {


    this.noticeService.showAllNotice.subscribe(res => {
      this.showAllNotice = res;
    });
    this.noticeService.showAddNotice.subscribe(res => {
      this.showAddNotice = res;
    });

    this.noticeService.showAddNotice.next(false);
    this.noticeService.showAllNotice.next(true);


    this.consultantInfo = consultant;
    this.consultantNotice = [];
    this.consultantReviews = [];
    this.transactions = [];
    this.consultantId = this.consultantInfo.consultantid;
    this.getConsultantNotice(this.consultantInfo.consultantid);
    this.getConsultantReviews(this.consultantInfo.consultantid);
    if (this.isLoggedIn$) {
      this.getCustomerTransactions(this.consultantInfo.consultantid);

    }
    this.consultantImageUrl = this.consultantInfo.consultantpictureurl;
    this.consultantName = this.consultantInfo.consultantlogin;

  }

  /**
   *
   * @param consultantId
   */
  getConsultantNotice(consultantId) {

    this.noticeService.consultantNotice(environment.merchantId, consultantId).subscribe(
      (result: any) => {

        if (result.statusCode === undefined) {

          this.consultantNotice = result.body;

        } else {
          $('#modalConsultantReviewsError').modal('show');

        }

      },
      (error: any) => {
        $('#modalConsultantReviewsError').modal('show');

      }
    );

  }

  /**
   *
   * @param consultantId
   */
  getConsultantReviews(consultantId) {

    this.noticeService.consultantReviews(environment.merchantId, consultantId).subscribe(
      (result: any) => {
        this.consultantReviews = result.body;
        if (result.statusCode === undefined) {
          $('#modalConsultantReviews').modal('show');

        } else {
          $('#modalConsultantReviewsError').modal('show');

        }

      },
      (error: any) => {
        $('#modalConsultantReviewsError').modal('show');

      }
    );

  }

  /**
   *
   * @param consultantId
   */
  getCustomerTransactions(consultantId) {
    const merchantId = environment.merchantId;
    this.noticeService.customerTransactions(
      merchantId,
      localStorage.getItem('customerId'),
      localStorage.getItem('customerSessionId'),
      consultantId
    ).subscribe(
      (result: any) => {
        if (result.body[0]) {
          this.transactions = result.body[0];
          this.transactionStatus.next(true);
        } else {
          this.transactionStatus.next(false);

        }
      },
      (error: any) => {
        $('#modalConsultantReviewsError').modal('show');

      }
    );

  }

  /**
   * Show Reviews
   */
  showAllNotices() {
    $('#reviews').css('height', '100%');
    $('.hiddenNotice').show();
    $('#btnShowAllNotices').hide();
  }

  /**
   * submit a Review
   */
  onSubmit() {
    this.customerRemark = this.formAddReview.value.customerRemark;

    const dataCustomerNoticeEnable = {
      merchantId: environment.merchantId,
      consultantId: parseInt(this.consultantId, 10),
      customerId: parseInt(localStorage.getItem('customerId'), 10),
      transactionId: this.transactions.transaction_id,
      sessionId: localStorage.getItem('customerSessionId'),
    };

    const dataCustomerNoticeSet = {
      transactionId: this.transactions.transaction_id,
      sessionId: localStorage.getItem('customerSessionId'),
      customerNoticeNotation: this.customerNoticeNotation,
      customerRemark: this.formAddReview.value.customerRemark
    };

    this.noticeService.customerNoticeEnable(dataCustomerNoticeEnable).subscribe(
      (result: any) => {

        this.noticeService.customerNoticeSet(dataCustomerNoticeSet).subscribe(
          (result2: any) => {
            $('#consultantAddNotice').hide();
            $('#consultantAllNotices').show();
            this.getCustomerTransactions(this.consultantId);
            this.customerNoticeNotation = 0;
            this.formAddReview.reset();

          },
          (error: any) => {
            this.getCustomerTransactions(this.consultantId);
            this.customerNoticeNotation = 0;
            this.formAddReview.reset();

          });

      }, (error => {
        this.customerNoticeNotation = 0;
        this.formAddReview.reset();
        $('#modalConsultantReviews').modal('hide');
        $('#modalConsultantAddReviewsError').modal('show');

      })
    );
  }

  addNotice() {
    $('#consultantAllNotices').hide();
    $('#consultantAddNotice').show();
    this.noticeService.showAddNotice.next(true);
    this.noticeService.showAllNotice.next(false);

  }

  /**
   * Show status of service based on mouse over event
   * @param statusCode
   * @param isActive
   */
  mouseOver(statusCode, isActive , service = 'all') {
    if (isActive === 1 && statusCode === 0) {
      this.tooltipClass = 'tooltip-available';
      this.activateLink = true;

    }
    if (statusCode === 1 || isActive === 2) {
      this.tooltipClass = 'tooltip-busy';
      this.activateLink = false;


    }
    if (isActive === 0) {
      this.tooltipClass = 'tooltip-unavailable';
      this.activateLink = false;

    }
    if (service === 'Audiotel') {
      this.tooltipClass = 'tooltip-available';
      this.activateLink = true;
    }

  }

  getSVANumberData(customerCountries) {
    this.showSVADetails = customerCountries[0] === 'FR';
    this.svaNumberPrice = this.svaNumbers[this.svaNumberTariff];
  }

  mouseOverLang() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  /**
   * @param activateLink
   */
  showSVAModal(activateLink) {
    this.consultantservice.showSVAModalAction(activateLink);
  }

  /**
   * @param consultantId
   */

  redirectToConsultant(consultantId) {
    // const  redirectTo = '/consultant-details';
    localStorage.setItem('ctcx', this.cryptoService.set(consultantId));
    localStorage.setItem('serviceType', this.cryptoService.set('all'));
    this.homeService.redirect('/consultant-details');
  }
  filter(type) {


    if (type === 'Audiotel') {

      if ($('#Audiotel').hasClass('fa-audiotel-unavailable')) {
        $('#Audiotel').addClass('fa-audiotel-available').addClass('available').removeClass('fa-audiotel-unavailable');
      } else {
        $('#Audiotel').addClass('fa-audiotel-unavailable').removeClass('fa-audiotel-available').removeClass('available');
      }

    }

    if (type === 'Conversation') {

      if ($('#Conversation').hasClass('fa-conv-unavailable')) {
        $('#Conversation').addClass('fa-conv-available').addClass('available').removeClass('fa-conv-unavailable');
      } else {
        $('#Conversation').addClass('fa-conv-unavailable').removeClass('fa-conv-available').removeClass('available');

      }

    }


    if (type === 'Chat') {

      if ($('#Chat').hasClass('fa-chat-unavailable')) {
        $('#Chat').addClass('fa-chat-available').addClass('available').removeClass('fa-chat-unavailable');
      } else {
        $('#Chat').addClass('fa-chat-unavailable').removeClass('fa-chat-available').removeClass('available');
      }


    }

    if (type === 'Mail') {


      if ($('#Mail').hasClass('fa-mail-unavailable')) {
        $('#Mail').addClass('fa-mail-available').addClass('available').removeClass('fa-mail-unavailable');
      } else {
        $('#Mail').addClass('fa-mail-unavailable').removeClass('fa-mail-available').removeClass('available');

      }

    }

    if (type === 'EN' || type === 'ES') {


      if ($('#' + type).hasClass('flag-border')) {
        $('#' + type).removeClass('flag-border').removeClass('available');
      } else {
        $('#' + type).addClass('flag-border').addClass('available');

      }

    }

    if (this.voyanceTypes.includes(type)) {
      if ($('#' + type).hasClass('badge-light')) {
        $('#' + type).removeClass('badge-light').removeClass('badge-unactive-mobiyo').addClass('badge-success').addClass('badge-active-mobiyo');
      } else {
        $('#' + type).removeClass('badge-success').removeClass('badge-active-mobiyo').addClass('badge-light').addClass('badge-unactive-mobiyo');

      }
    }


  }

  addFilter(event) {
    if (event.currentTarget.id === 'consultant') {
      this.filters.consultantName = event.target.value;
    }
    if (event.currentTarget.id === 'timeFrames') {
      this.filters.timeFrames = event.target.innerText;
    }
    this.filter(this.filters.timeFrames);
    this.filter(event.currentTarget.id);

    if (Object.values(event.currentTarget.classList).indexOf('consultation_modes') > -1 && Object.values(event.currentTarget.classList).indexOf('available') > -1) {
      this.filters.consultationModesFilter.indexOf(event.currentTarget.id) === -1 ? this.filters.consultationModesFilter.push(event.currentTarget.id) : '';
    } else if (Object.values(event.currentTarget.classList).indexOf('consultation_modes') > -1 && Object.values(event.currentTarget.classList).indexOf('available') === -1) {
      this.filters.consultationModesFilter.splice(this.filters.consultationModesFilter.indexOf(event.currentTarget.id), 1);
    } else if (Object.values(event.currentTarget.classList).indexOf('voyance_types') > -1 && Object.values(event.currentTarget.classList).indexOf('badge-active-mobiyo') > -1) {
      this.filters.voyanceTypesFilter.indexOf(event.currentTarget.id) === -1 ? this.filters.voyanceTypesFilter.push(event.currentTarget.id) : '';
    } else if (Object.values(event.currentTarget.classList).indexOf('voyance_types') > -1 && Object.values(event.currentTarget.classList).indexOf('badge-active-mobiyo') === -1) {
      this.filters.voyanceTypesFilter.splice(this.filters.voyanceTypesFilter.indexOf(event.currentTarget.id), 1);
    } else if (Object.values(event.currentTarget.classList).indexOf('languages_types') > -1 && Object.values(event.currentTarget.classList).indexOf('available') > -1) {
      this.filters.languagesTypesFilter.indexOf(event.currentTarget.id) === -1 ? this.filters.languagesTypesFilter.push(event.currentTarget.id) : '';
    } else if (Object.values(event.currentTarget.classList).indexOf('languages_types') > -1 && Object.values(event.currentTarget.classList).indexOf('available') === -1) {
      this.filters.languagesTypesFilter.splice(this.filters.languagesTypesFilter.indexOf(event.currentTarget.id), 1);
    } else {
    }


    this.getFilteredData();

  }

  getFilteredData() {
   
    
    this.listDataFiltered = [];
    this.listData = this.listDataOriginal;
    this.listData.forEach((consultant, index) => {

      let consultyantName = consultant.consultantlogin;
      if (consultyantName == null) {
        consultyantName = '';
      }

      if (this.filters.consultantName !== '') {
        if (
          consultyantName.toLowerCase().includes(this.filters.consultantName.toLowerCase()) &&
          this.filters.consultationModesFilter.every(elem => consultant.prestations.includes(elem)) &&
          this.filters.voyanceTypesFilter.every(elem => consultant.voyanceTypes.includes(elem)) &&
          this.filters.languagesTypesFilter.every(elem => consultant.language.includes(elem))
        ) {
          this.listDataFiltered.push(consultant);
        }

      } else {

        if (
          this.filters.consultationModesFilter.every(elem => consultant.prestations.includes(elem)) &&
          this.filters.voyanceTypesFilter.every(elem => consultant.voyanceTypes.includes(elem)) &&
          this.filters.languagesTypesFilter.every(elem => consultant.language.includes(elem))
        ) {
          this.listDataFiltered.push(consultant);
        }

      }
    });
    if ( this.servicetype === 'Audiotel') {
      const currentHour = dayjs().format('HH') + 'h';
      const selectedHour =  this.filters.timeFrames.substring(0, 3) || currentHour  ;
      const selectedDay = (document.getElementById('selectedDayId') as HTMLInputElement).value || dayjs().format('YYYY-MM-DD');
      if (dayjs().format('YYYY-MM-DD') !== selectedDay) {
        this.listDataFiltered  = this.filterAudiotelPlanningByDay(this.listDataCloned  , selectedHour , selectedDay);
        this.listDataFiltered = this.sortByTouchNumber(this.listDataFiltered, selectedHour , selectedDay);
        this.dayName = dayjs(selectedDay).format('dddd');
        this.dayNumber = dayjs(selectedDay).format('DD');
        this.monthName = dayjs(selectedDay).format('MMMM');
        this.yearNumber = dayjs(selectedDay).format('YYYY');
      } else {
        this.listDataCloned.forEach(elementData => {
          elementData.planningDays.forEach(el => {
              if (el.day === selectedDay ) {
                elementData.startHour = el.startHour;
              }
              if (el.day === dayjs().format('YYYY-MM-DD')) {
                elementData.isPlannedForToday = true;

              }
          });
      
        });
       
        this.listDataFiltered = this.listDataCloned ;


   
       this.listDataFiltered.forEach(element => {
       // console.log(element);
          if(element.planning[selectedDay] ){
               let element_planning :any = {} ;
               let hourFrame:any = {};
               element.planning[selectedDay].forEach(p=> { 
                
              //  console.log(selectedHour.replace('h',':00:00') ,element.consultantlogin , p.frames.includes(selectedHour.replace('h',':00:00')));
      
                  if(p.frames){
                    p.frames.forEach(frame=>{
                      if(frame.startHourFrame === selectedHour.replace('h',':00:00')){
                        element_planning = p ;
                        hourFrame = frame ;
                      }

                    });
                  }
             
              
              });

  
           if(element_planning){
                if(((element_planning.serviceType?.indexOf('audiotel') >= 0 || element.consultantstate === 1) && element.consultantavailable &&  selectedHour != currentHour) || (element_planning.serviceType?.indexOf('audiotel') >= 0 && element.consultantstate === 5 && selectedHour != currentHour )) {                  
                  element.statut = 'Touche : ' + hourFrame?.toucheFrame;
                  element.colorClass = 'bg-pink';
                  element.statutCode = -2;
                  element.statutColor =  'bg-pink';
                }
                else if(((element_planning.serviceType?.indexOf('audiotel') >= 0 || element.consultantstate === 1) && element.consultantavailable &&  selectedHour === currentHour) || (element_planning.serviceType?.indexOf('audiotel') >= 0 && element.consultantstate === 5 && selectedHour === currentHour ))               
                {
                  element.statut = 'JE CONSULTE IMMEDIATEMENT';
                  element.statutColor = 'bg-success';
                  element.statutCode = 0;
                  element.colorClass = 'bg-success';
                }
            }
          }
        }
        
       );
      
        
        this.listDataFiltered = this.listDataFiltered.filter(data => (
          data.startHour.includes(selectedHour) && data.isPlannedForToday === true
          && ( data.statutCode === 0  || data.statutCode ===  -2 )/*&& dayjs(data.date).format('HH') === selectedHour.substring(0, 2)*/));

        this.listDataFiltered = this.sortByTouchNumber(this.listDataFiltered, selectedHour , selectedDay);

        this.dayName = dayjs().format('dddd');
        this.dayNumber = dayjs().format('DD');
        this.getCurrentActiveEl(dayjs());


      }
    }
    this.listData = this.listDataFiltered;
   
  }


  showVoyanceType() {

    if ($('#row-voyance-types:visible').length === 0) {
      $('.row-voyance-types').fadeIn('slow');
      $('#search-advanced-icon').removeClass('fa-chevron-down').addClass('fa-chevron-up');

    } else {
      $('.row-voyance-types').fadeOut('slow');
      $('#search-advanced-icon').removeClass('fa-chevron-up').addClass('fa-chevron-down');

    }

  }

  /**
   * Generate an array of hours
   */
  generateTimeFrame() {
    const x = 60;
    const times = [];
    let tt = 0;
    for (let i = 0; tt < 24 * 60; i++) {
      const hh = Math.floor(tt / 60);
      times[i] = hh;
      tt = tt + x;
    }
    const formattedTimes = times.map(res => (
      ((res) + 'h').padStart(3, '0') + ' - ' + ((res + 1) + 'h').padStart(3, '0')
    ));


    return formattedTimes;


  }

  /**
   * get current active slider element
   */
  async getCurrentActiveEl(day) {
    const currentHour = dayjs().format('HH');
    const timeFrameNow = (currentHour + 'h' + ' - ' + (dayjs().add(1, 'h')).format('HH')) + 'h';
    const timeFrames: string[] = this.generateTimeFrame();
    for (const [key, value] of Object.entries(timeFrames)) {
      if (timeFrameNow === value) {
        this.startSlider = Number(key);
      }
    }
    const el: HTMLCollectionOf<Element> = await document.getElementsByClassName('slick-slide');
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < el.length; i++) {
      // @ts-ignore
      const Element = el[i].innerText.substring(0, 2);
      if (Element < this.startSlider  && day.isToday()) {
        // @ts-ignore
        el[i].style.pointerEvents = 'none';
        // @ts-ignore
        el[i].style.opacity = '0.4';
      } else {
        // @ts-ignore

        el[i].style.pointerEvents = 'unset';
        // @ts-ignore
        el[i].style.opacity = 'unset';
      }
    }
  }

  /**
   *
   * @param data
   * @param selectedHour
   */
  sortByTouchNumber(data , selectedHour , seletedDay ) {
    data.forEach(el => {
       el.framesDetails.forEach(frame => {
        // console.log('frame.startHourFrame.substring(0, 2)' , frame.startHourFrame.substring(0, 2) + 'h' === selectedHour);
         if ((frame.startHourFrame.substring(0, 2) + 'h') === selectedHour && dayjs(frame.day).format('YYYY-MM-DD') === dayjs(seletedDay).format('YYYY-MM-DD') ) {
           el.touchNumber = frame.toucheFrame;
         }
       });

    });
    return  data.sort((a, b) => a.touchNumber - b.touchNumber);
  }

  /**
   *
   * @param data
   * @param selectedHour
   * @param selectedDay
   */
  filterAudiotelPlanningByDay( data  , selectedHour , selectedDay) {
    const currentHour = dayjs().format('HH') + 'h';

    data.forEach( el => {
      el.planningDays.forEach( element => {
          if (element.day === selectedDay && element.startHour.includes(selectedHour)) {
            el.statut = 'JE CONSULTE IMMEDIATEMENT';
            el.statutColor = 'bg-success';
            el.isPlannedForToday = false;
            el.day = selectedDay;
            el.statutCode = 0;
            el.startHour = element.startHour;
            this.dayNumber = dayjs(selectedDay).format('DD');
            this.dayName = dayjs(selectedDay).format('dddd');
          }});
    }) ;
    data = data.filter(el => (
      ( el.startHour.includes(selectedHour)  &&  el.day === selectedDay)
      ||  (data.statutCode === 0 && selectedHour === currentHour)));
    this.getCurrentActiveEl(dayjs(selectedDay));
    return data;
  }

  /**
   * hide audiotel service
   * @param data
   */
  filterService(data) {
    data.forEach(el => {
      el.prestationSorted = el.prestationSorted.filter(item => item.name !== 'Audiotel');
    });
    return data;
  }

  refreshPage(){
    this.ngOnInit();
  }
  hideRefreshModal(){
    $('#refresh-page-modal').modal('hide');
  }



}

